import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class PerformanceBreakdownService {
  constructor(private http: HttpClient) {}

  public query(params: any) {
    let projectId;
    let routeId;

    [params, projectId, routeId] = splayParams(params, "projectId", "routeId");
    const url = `/api/v5/projects/${projectId}/routes/${routeId}/breakdowns`;

    return this.http.get(url, { params }).pipe(
      map((data: any) => {
        // Temp remove `other` group until airbrake/product#1018 is fixed.
        if (typeof data.groups === "object" && "other" in data.groups) {
          delete data.groups.other;
        }
        return data;
      }),
    );
  }
}
